import React from "react";
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from "isomorphic-style-loader/withStyles";

import ConfigSettingsForm from '../../../components/siteadmin/ConfigSettingsForm'
import Loader from '../../../components/Loader/Loader';

import { decode } from '../../../helpers/queryEncryption';
import { censorWord } from '../../../helpers/secureEmail';
import { withQuery } from "../../../hoc/withGraphql";
import { salesUser } from '../../../helpers/DemoRestriction/demo';

import s from './ConfigSettings.css';

const ConfigSettings = (props) => {

    const { data: { loading, siteSettings }, adminId, isDemoRestricted } = props;
    const settingsCollection = {};

    if (loading) {
        return <Loader type={"text"} />;
    } else {
        siteSettings?.map((item, key) => {
            if (item.name == 'paypalHost') settingsCollection[item.name] = decode(item.encryptValue);
            else settingsCollection[item.name] = (isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0) ? censorWord(decode(item.encryptValue)) : decode(item.encryptValue)
        });
        return <ConfigSettingsForm initialValues={settingsCollection} />
    }
}

ConfigSettings.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        siteSettings: PropTypes.array,
    })
}

ConfigSettings.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
    withQuery(gql`
{
  siteSettings {
    name
    encryptValue
  }
}
`, {
        options: (props) => ({
            variables: {
                name: 'config_settings',
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }
    ),
)(ConfigSettings);





